import { render } from "./PaymentPlansPage.vue?vue&type=template&id=36bd2ba1"
import script from "./PaymentPlansPage.vue?vue&type=script&lang=js"
export * from "./PaymentPlansPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__